<template>
  <b-card class="card">
    <b-card-body class="p-1">
      <h4 class="card-title mb-4">{{ $t('pages.dashboard.last_feedbacks.title', {days: 10})}}</h4>

      <simplebar style="height: 370px !important;">
        <loader :loading="statistics.loading" height="370px">
          <div v-if="statistics.data && statistics.data.length > 0">
            <ul class="list-group list-group-flush">
              <li class="list-group-item py-3" v-for="(feedback, index) in statistics.data" :key="index">
                <div class="media">
                  <div class="media-body">
                    <h5 class="font-size-14 mb-1">
                      {{ feedback.detail.order }}
                      <small class="text-muted float-end">{{ feedback.date }}</small>
                    </h5>
                    <p class="text-muted">
                      {{ feedback.comment }}
                    </p>
                    <Star :star="feedback.rating"></Star>
                    <p>
                      {{ feedback.detail.buyer }}
                    </p>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <no-content v-else :loading="statistics.loading" height="370px"/>
        </loader>
      </simplebar>
    </b-card-body>
  </b-card>
</template>
<script>
import Star from "../../Reviews/components/Star";
import simplebar from "simplebar-vue";

export default {
  name: 'LastFeedbacks',
  components: {
    Star,
    simplebar
  },
  props: ['statistics'],
};
</script>

